import React, { createRef, Dispatch, FC, ReactElement, Ref, SetStateAction } from 'react'
import { TrophyMemoryDto } from '~/modules/Trophies/Infrastructure/TrophyDetailComponentDto'
import styles from './TrophyMemoryLightbox.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CSSTransition } from 'react-transition-group'
import TailwindConfig from '~/tailwind.config'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'

interface Props {
  memory: TrophyMemoryDto
  active: boolean
  setActive: Dispatch<SetStateAction<boolean>>
}

export const TrophyMemoryLightbox: FC<Props> = ({ memory, active, setActive }) => {
  let media: ReactElement
  const videoPlayer: Ref<HTMLVideoElement> = createRef()
  const audioPlayer: Ref<HTMLAudioElement> = createRef()

  switch (memory.type) {
    case 'video':
      media = (
        <video
          data-qa='trophy-memories-lightbox-video'
          className={ styles.trophyMemoryLightbox__trophyMemoriesLightboxVideo }
          poster={ memory.thumbnailUrl }
          loop={ true }
          autoPlay={ false }
          muted={ false }
          controls
          ref={ videoPlayer }
          onClick={ (event) => event.stopPropagation() }
        >
          <source
            src={ memory.mediaUrl }
            type={ 'video/mp4' }
          />
        </video>
      )
      break

    case 'image':
      media = (
        <img
          data-qa='trophy-memories-lightbox-image'
          className={ styles.trophyMemoryLightbox__trophyMemoriesLightboxImage }
          alt={ '' }
          src={ memory.mediaUrl }
        />
      )
      break

    case 'audio':
      media = (
        <audio
          data-qa='trophy-memories-lightbox-audio'
          className={ styles.trophyMemoryLightbox__trophyMemoriesLightboxAudio }
          src={ memory.mediaUrl }
          controls
          ref={ audioPlayer }
          onClick={ (event) => event.stopPropagation() }
        />
      )
      break
  }

  return (
    <CSSTransition
      classNames={ {
        enter: styles.trophyMemoryLightbox__trophyMemoriesLightboxEnter,
        enterActive: styles.trophyMemoryLightbox__trophyMemoriesLightboxEnterActive,
        enterDone: styles.trophyMemoryLightbox__trophyMemoriesLightboxEnterDone,
        exit: styles.trophyMemoryLightbox__trophyMemoriesLightboxExit,
        exitActive: styles.trophyMemoryLightbox__trophyMemoriesLightboxExitActive,
        exitDone: styles.trophyMemoryLightbox__trophyMemoriesLightboxExitDone,
      } }
      in={ active }
      timeout={ parseInt(TailwindConfig.theme.extend.transitionDuration.DEFAULT) }
    >
      <div
        data-qa='trophy-memories-lightbox'
        className={ styles.trophyMemoryLightbox__trophyMemoriesLightbox }
        onClick={ () => {
          setActive(false)
          audioPlayer.current?.pause()
          videoPlayer.current?.pause()
        } }>
        <div className={ styles.trophyMemoryLightbox__mediaContainer }>
          { media }

          <FontAwesomeIcon
            icon={ faXmark }
            className={ styles.trophyMemoryLightbox__trophyMemoriesLightboxIcon }
          />
        </div>

      </div>

    </CSSTransition>
  )
}
